import qs from 'qs';
import axios from '../../../utils/customAxiosUtil';

export const mainDashAPI = {
  stcsDay: async (data: string) => {
    const queryString = qs.stringify(data, {
      addQueryPrefix: true,
      arrayFormat: 'repeat'
    });
    return await axios.get(`api/main/dash/stcs/day${queryString}`);
  },
  stcsArea: async (data: string) => {
    const queryString = qs.stringify(data, {
      addQueryPrefix: true,
      arrayFormat: 'repeat'
    });
    return await axios.get(`api/main/dash/stcs/area${queryString}`);
  },

  groupList: async (data: number) => {
    const queryString = qs.stringify(data, {
      addQueryPrefix: true,
      arrayFormat: 'repeat'
    });
    return await axios.get(`api/main/dash/group/list${queryString}`);
  },

  dronList: async (data: number) => {
    const queryString = qs.stringify(data, {
      addQueryPrefix: true,
      arrayFormat: 'repeat'
    });
    return await axios.get(`api/main/dash/arcrft/list${queryString}`);
  }
};
